import { useQuery } from "@tanstack/react-query"
import { projectApi } from "@/services/project-api"
import { queryKeys } from "./query-keys"
import { useAuthReady } from "./use-auth-ready"
import { useCurrentTenant } from "./use-current-tenant"

export function useProjects() {
  const isAuthReady = useAuthReady()
  const { data: tenant } = useCurrentTenant()

  return useQuery({
    queryKey: queryKeys.projects.list(tenant?.id),
    queryFn: () => projectApi.getProjectsByTenant(),
    enabled: isAuthReady && tenant !== undefined,
    throwOnError: true,
  })
}
